import { Link } from "react-router-dom";
import { useState } from "react";
import Select from 'react-select';
const Nav: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">Stock Dashboard</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" onClick={() => setIsOpen(!isOpen)}>
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link active" aria-current="page" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/price-list">Price List</Link>
                        </li>
                    </ul>
                    <div className="position-relative ms-auto">
                    <Select
                            id="searchBox"
                            className="form-control"
                            placeholder="Nhập mã chứng khoán..."
                            aria-label="Search"
                            isClearable 
                           />
                    </div>
                </div>
            </div>
        </nav>
    )
}
export default Nav;